<template>
	<div class="position-relative" style="height: 100dvh; background: lightgray">
		<section class="su-mobile-container">
			<SignupForm :signinCheckData="signinCheckData" @next="$emit('next')" />
		</section>
	</div>
</template>

<script>
import SignupForm from "./SignupForm.vue";

export default {
	name: "Signup",
	components: {
		SignupForm,
	},
	props: {
		signinCheckData: {
			type: Object,
			default: null,
		},
	},
};
</script>

<style scoped>
.su-mobile-container {
	max-height: 500px;
	min-height: auto;
	background: #ffffff;
	border-radius: 40px 40px 0px 0px;
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	padding: 16px;
}
</style>
